import { useState } from 'react';
import { DropletsIcon, LightbulbIcon, SproutIcon } from './HomeIcons';

const applicationLinks = [
  { href: '/applications/home-garden', label: 'Home & Garden' },
  { href: '/applications/agriculture', label: 'Agriculture' },
  { href: '/applications/nursery-landscaping', label: 'Nursery & Landscaping' }
];

export default function Header({ scrolled }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <header className={`header${scrolled ? ' scrolled' : ''}`} role="banner">
        <div className="header-inner">
          <a href="/" className="logo-wrap" aria-label="Paras Organics Home">
            <img src="/images/paras-logo.png" alt="Paras Organics" />
          </a>
          <nav className="nav" aria-label="Main navigation">
            { /*<a href="/">Home</a>*/}
            <a href="/vermicompost">Vermicompost</a>
            <a href="/vermiwash">Vermiwash</a>
            <div className="nav-dropdown">
              <button className="nav-dropdown-toggle" aria-haspopup="true" aria-expanded="false">
                Applications
              </button>
              <div className="nav-dropdown-menu">
                {applicationLinks.map((link) => (
                  <a key={link.href} href={link.href}>{link.label}</a>
                ))}
              </div>
            </div>
            {/*<a href="#about">About</a>*/}
            <a href="/blog">Blog</a>
            <a href="/contact">Contact Us</a>
            {/*<a href="/login" className="nav-auth-btn" style={{ textDecoration: 'none', padding: '0.45rem 1rem', borderRadius: '5px', border: '1.5px solid #e0e0e0', fontSize: '0.82rem', fontWeight: 600, color: '#1c1c1c', transition: 'all 0.2s', display: 'inline-block' }}>Login / Sign Up</a>*/}
          </nav>
          <div className="header-actions">
            <button
              className={`hamburger${mobileOpen ? ' open' : ''}`}
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Menu"
              aria-expanded={mobileOpen}
            >
              <span /><span /><span />
            </button>
          </div>
        </div>
      </header>

      <div className={`mobile-menu${mobileOpen ? ' open' : ''}`} role="dialog" aria-label="Mobile navigation">
        <a href="/vermicompost" onClick={() => setMobileOpen(false)}><SproutIcon className="ui-icon mobile-menu-icon" />Vermicompost</a>
        <a href="/vermiwash" onClick={() => setMobileOpen(false)}><DropletsIcon className="ui-icon mobile-menu-icon" />Vermiwash</a>
        <a href="/applications/home-garden" onClick={() => setMobileOpen(false)}><SproutIcon className="ui-icon mobile-menu-icon" />Applications</a>
        <a href="/blog" onClick={() => setMobileOpen(false)}><LightbulbIcon className="ui-icon mobile-menu-icon" />Blog</a>
        <a href="/contact" onClick={() => setMobileOpen(false)}><LightbulbIcon className="ui-icon mobile-menu-icon" />Contact Us</a>
      </div>
    </>
  );
}
